var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgInvalidicon(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 128,
    height: 128,
    viewBox: "0 0 128 128",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M64 2C98.25 2 126 29.75 126 64C126 98.25 98.25 126 64 126C29.75 126 2 98.25 2 64C2 29.75 29.75 2 64 2ZM64 118C93.75 118 118 93.75 118 64C118 34.25 93.5 10 64 10C34 10 10 34.5 10 64C10 94 34.25 118 64 118ZM87.5 46.75L70.25 64L87.5 81.5C88.75 82.5 88.75 84.5 87.5 85.75L85.5 87.75C84.25 89 82.5 89 81.25 87.75L64 70.5L46.5 87.75C45.5 89 43.5 89 42.25 87.75L40.25 85.75C39 84.5 39 82.5 40.25 81.5L57.5 64L40.25 46.75C39 45.5 39 43.75 40.25 42.5L42.25 40.5C43.5 39.25 45.5 39.25 46.5 40.5L64 57.75L81.25 40.5C82.5 39.25 84.25 39.25 85.5 40.5L87.5 42.5C88.75 43.75 88.75 45.5 87.5 46.75Z",
    fill: "#BE5C5C"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgInvalidicon);
export default __webpack_public_path__ + "static/media/invalidicon.24907bf7295f7018c6aaf4fd94f1b74a.svg";
export { ForwardRef as ReactComponent };